import { useInfiniteQuery } from 'react-query';
import { BenefitListRequest } from './benefits.types';
import benefitsServices from './benefits.services';
import { queryClient } from '@/Root';

export const QUERY_BENEFIT_LIST = 'benefit/list';

export function useBenefitList(params?: BenefitListRequest, enabled = true) {
  const queryKey = [QUERY_BENEFIT_LIST, { ...params }];
  const cache = queryClient.getQueryData(queryKey);

  return useInfiniteQuery({
    queryKey,
    queryFn: ({ pageParam }) =>
      benefitsServices.list({ ...params, nextToken: pageParam }),
    getNextPageParam: (lastPage) => lastPage.nextToken,
    enabled: enabled && !cache,
  });
}
